<template>
  <form
    ref="form"
    data-url="/accreditationtechnical/selection/evaluationTestification/update"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12" v-if="evaluations && evaluations.length > 0">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            Seleccione las evaluaciones/testificaciones a las que desea agrupar
            con <b>{{ code }}</b
            >, si no desea agrupar agregue el o los archivos necesarios y
            continúe con el proceso normalmente
          </h5>
        </legend>
      </div>
      <div class="col-12" v-if="evaluations && evaluations.length > 0">
        <app-note
          class="pt-2 clearfix"
          :title="$t('Procesos en bloque')"
          content-type="html"
          note-type="note-warning"
          :notes="[
            $t(
              'Las evaluaciones o testificaciones que aparecen en estas sección son las que ya tienen una planificación previa'
            ),
          ]"
        />
      </div>
      <div class="col-12" v-if="evaluations && evaluations.length > 0">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
              <th scope="col" class="text-center" style="width: 10%">
                Seleccionar
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluations" :key="key">
              <td class="align-middle" v-if="value">
                {{ value.accreditation_applications.record }}
              </td>
              <td class="align-middle" v-if="value">
                <br />
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle" v-if="value">{{ value.code }}</td>
              <td class="align-middle text-center" v-if="value">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="value.combo"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label
            >Propuesta de designación de equipo evaluador:
            <strong class="text-danger">*</strong></label
          >
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-model="inputs.file"
            :required="true"
            :disabled="disabledsupport"
            v-if="!inputs.evaluation_team_file"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'evaluation_team_file')"
              v-if="inputs.evaluation_team_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              :disabled="disabledsupport"
              @click.prevent="openDeleteModal('evaluation_team_file')"
              v-if="inputs.evaluation_team_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-6" v-if="is_laboratory">
        <div class="form-group">
          <label>Plan de muestreo: <strong class="text-danger">*</strong></label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            :disabled="disabledsupport"
            v-if="!inputs.sampling_plan_file"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'sampling_plan_file')"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              :disabled="disabledsupport"
              @click.prevent="openDeleteModal('sampling_plan_file')"
              v-if="inputs.sampling_plan_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-6" v-if="is_laboratory">
        <div class="form-group">
          <label>Matriz de riesgos: <strong class="text-danger">*</strong></label>
          <app-input
              type="file"
              :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
              v-model="inputs.file_2"
              :required="true"
              :disabled="disabledsupport"
              v-if="!inputs.matrix_file"
          />
          <div class="mt-2">
            <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'matrix_file')"
                v-if="inputs.matrix_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
                type="submit"
                class="btn btn-danger"
                :disabled="disabledsupport"
                @click.prevent="openDeleteModal('matrix_file')"
                v-if="inputs.matrix_file"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          :disabled="disabledsupport"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <legend>
          <small class="text-primary">Documentos anteriores a la evaluación</small>
        </legend>
      </div>
      <div class="col-12">
        <div class="row mb-2" v-for="(vj, j) in last_evaluation_document" :key="j">
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
              >Tamaño máximo del archivo 8 Mb</small
            >
          </div>

          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              :disabled="disabledsupport"
              @click.prevent="openDeleteModalLastEvaluation(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
              :id="`filename_${j}`"
              type="text"
              v-model="vj.filename"
              placeholder="Descripcion del archivo"
              :disabled="disabledsupport"
              @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
              >Es necesario agregar una descripción</small
            >
          </div>

          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click.prevent="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" :disabled="disabledsupport" @click.prevent="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
      </div>
    </div>

    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />

    <app-confirmation-modal
      v-if="deleteModalastEval"
      modal-id="delete"
      @confirmed="confirmedDoc"
      @cancelled="cancelledDoc"
    />

      
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";
// import * as actions from "../../../../apiUrl";
export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      evaluations: [],
      is_laboratory: false,
      docs: "",
      code: "",
      last_evaluation_document: [],
      deleteModalastEval: false,
      disabledsupport: false,
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
    this.dataInfo();
    this.dataAcc();
    this.dataList();
  },

  methods: {
    dataInfo() {
      let url = `/accreditationtechnical/selection/evaluationTestification/show?evalTestId=${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        // this.inputs = response.data;
        var laboratory =
          response.data.accreditation_applications.accreditation_area.name;
        if (laboratory == "LABORATORIOS") {
          this.is_laboratory = true;
        }
        this.code = response.data.code;
        this.last_evaluation_document = response.data.last_evaluation_document;
      });
    },
    dataAcc() {
      this.preloader = true;
      let url = `/accreditations/session/showauth/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (response?.data) {
              //id session
              this.axiosGet(
                  `/accreditations/session/getauth`
                )
                  .then((rsession) => {
                    if (rsession.status == 200) {
                      if (response.data.support_technique == rsession.data && response.data.responsible_technician != response.data.support_technique) {
                        this.disabledsupport = true;
                      } else {
                        this.disabledsupport = false;
                      }
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  })
                  .finally(() => {});
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    dataList() {
      let url = `/accreditationtechnical/selection/evaluationTestification/evaluationList/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        if (response.data[0] != null) {
          this.evaluations = response.data;
        }
      });
    },
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append(
        "accreditationId",
        this.$store.state.evaluatorReview.evalTestId
      );
      formData.append("evaluations", JSON.stringify(this.cleanArray(this.evaluations)));
      this.save(formData);
    },

    cleanArray(actual) {
      var newArray = new Array();
      for (var i = 0, j = actual.length; i < j; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    },

    afterSuccess({ data: { data } }) {
      this.preloader = false;
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabFor(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },

    loadForm() {
      let url = `/accreditationtechnical/selection/evaluationTestification/show?evalTestId=${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        // this.inputs = response.data;
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          evaluation_team_file: response.data.evaluation_team_file,
          sampling_plan_file: response.data.sampling_plan_file,
          matrix_file: response.data.risk_matrix
        };
      });
      /* if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          evaluation_team_file:
            this.$store.state.evaluatorReview.evalTest.evaluation_team_file,
          sampling_plan_file:
            this.$store.state.evaluatorReview.evalTest.sampling_plan_file,
        };
      } */
    },

    onKeyUp(j) {
      const tmp = this.last_evaluation_document[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    openFileTab(file) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.$store.state.evaluatorReview.evalTestId;
      info['path'] = String(file.path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    onChange(e, j) {
      const tmp = this.last_evaluation_document[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.last_evaluation_document[j], "file", null);
        this.$set(
          this.last_evaluation_document[j],
          "filename",
          null
        );
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename)
        this.$set(
          this.last_evaluation_document[j],
          "filename",
          ""
        );
      this.chargeFile(j);
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/accreditationtechnical/selection/evaluationTestification/addFileAttachLastEvaluation`;
      const tmpo = this.last_evaluation_document[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.last_evaluation_document[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.last_evaluation_document];
            tmp[j] = data;
            this.last_evaluation_document = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    removeRowFile(j) {
      this.last_evaluation_document =
        this.last_evaluation_document.filter(
          (value, index) => index != j
        );
    },

    addFile() {
      if (this.last_evaluation_document.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.last_evaluation_document.push({
        record_id: this.$store.state.evaluatorReview.evalTestId,
        filename: null,
        file: null,
      });
    },

    openDeleteModalLastEvaluation(j, vj) {
      this.deleteModalastEval = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    confirmedDoc() {
      const url = `/accreditationtechnical/selection/evaluationTestification/destroyFileAttachLastEvaluation?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModalastEval = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "last_evaluation_document") {
            const tmp = this.last_evaluation_document.filter(
              (value, index) => index != this.tmp.j
            );
            this.last_evaluation_document = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    cancelledDoc() {
      this.deleteModalastEval = false;
    },

  },
};
</script>
